export enum DataSourceTypeEnum {
  STREAMETRIC_AI = 'streametric_ai',
  WEATHER_API = 'weather_api',
  LOGS = 'logs',
  ASSET_PROPERTIES = 'asset_properties',
}
